import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import * as Yup from 'yup';
import { requiredFiles } from '../../../useValidateQuestionnaire';
import {
  DividendsStateValues,
  TForeignDividendsIndicateCurrency,
  TForeignDividendsIndicateCurrencyItem,
  TUsDividendsIn,
  TUsDividendsInItem,
  updateFieldArrayKey,
  updateKey,
} from './slice';

// predicate:
//       'Displayed in case the user selected Yes to the "I receive dividends" question',

export const fields: IBaseField<
  | keyof DividendsStateValues
  | keyof TUsDividendsInItem
  | keyof TForeignDividendsIndicateCurrencyItem
>[] = [
  {
    name: 'didYouReceiveAnyDividendIncomeDuringTheFilingYear',
    label: 'Did you receive any dividend income during the filing year?',
    subLabel: () => <p>Refers to spouse as well.</p>,
    type: 'select',
    options: [
      {
        label: 'Yes - US Dividends Only',
        value: 'Yes - US Dividends Only',
      },
      {
        label: 'Yes - Non-US Dividends Only',
        value: 'Yes - Non-US Dividends Only',
      },
      {
        label: 'Yes - Both US & Foreign Dividends',
        value: 'Yes - Both US & Foreign Dividends',
      },
      {
        label: 'No',
        value: 'No',
      },
    ],
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        label: () => <h3 className="font-semibold">U.S. Dividends</h3>,
        type: 'information',
        predicate: (value) =>
          value === 'Yes - US Dividends Only' ||
          value === 'Yes - Both US & Foreign Dividends',
      },
      {
        name: 'pleaseUploadForm1099Div',
        label: 'Please upload Form 1099-DIV',
        type: 'upload',
        predicate: (value) =>
          value === 'Yes - US Dividends Only' ||
          value === 'Yes - Both US & Foreign Dividends',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'doTheFilesYouUploadedIncludeEveryUsDividendDisbursalYouReceivedDuringYear',
        label:
          'Do the files you uploaded include every US dividend disbursal you received during {year}?',
        type: 'radio',
        predicate: (value) =>
          value === 'Yes - US Dividends Only' ||
          value === 'Yes - Both US & Foreign Dividends',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'usDividendsIn',
            label: 'US Dividends in $',
            type: 'fieldArray',
            predicate: (value) => value === 'no',
            tooltip: '',
            comment: true,
            effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
            defaultDependency: {
              nameOfPayer: null,
              ordinaryDividends: null,
              qualifiedDividends: null,
              capitalGainsDistributions: null,
              nonTaxableDistributions: null,
              taxWithheld: null,
            },
            dependencies: [
              {
                name: 'nameOfPayer',
                label: 'Name of Payer',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'ordinaryDividends',
                label: 'Ordinary Dividends $',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'qualifiedDividends',
                label: 'Qualified Dividends $',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'capitalGainsDistributions',
                label: 'Capital Gains Distributions $',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'nonTaxableDistributions',
                label: 'Non-taxable Distributions $',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
              {
                name: 'taxWithheld',
                label: 'Tax Withheld $',
                type: 'text',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                placeholder: 'Enter',
              },
            ],
          },
        ],
      },
      {
        label: () => <h3 className="font-semibold">Non-U.S. Dividends</h3>,
        type: 'information',
        predicate: (value) =>
          value === 'Yes - Non-US Dividends Only' ||
          value === 'Yes - Both US & Foreign Dividends',
      },
      {
        name: 'foreignDividendsIndicateCurrency',
        label: 'Foreign Dividends - Indicate Currency',
        type: 'fieldArray',
        tooltip: '',
        comment: true,
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        defaultDependency: {
          nameOfPayer: null,
          grossAmount: null,
          withholdingifAny: null,
          frandkedCreditsifApplicable: null,
        },
        predicate: (value) =>
          value === 'Yes - Non-US Dividends Only' ||
          value === 'Yes - Both US & Foreign Dividends',
        dependencies: [
          {
            name: 'nameOfPayer',
            label: 'Name of Payer',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
          {
            name: 'grossAmount',
            label: 'Gross Amount',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },

          {
            name: 'withholdingifAny',
            label: 'Withholding (if any)',
            type: 'currency',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },

          {
            name: 'frandkedCreditsifApplicable',
            label: 'Frandked credits (if applicable)',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
        ],
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
